module.exports = __webpack_public_path__ + "img/appointment.7ef363a.webp";